var map = {
	"./ErrorPages/404.vue": [
		"898f",
		"chunk-2d0df2e5"
	],
	"./Index/floor1.vue": [
		"c66e",
		"chunk-608938f3"
	],
	"./Index/floor2.vue": [
		"258e",
		"chunk-5d5a6b87"
	],
	"./Index/floor3_new.vue": [
		"5bf5",
		"chunk-07efb115"
	],
	"./Index/floor5.vue": [
		"a07d",
		"chunk-3bb5c006"
	],
	"./Index/floor6.vue": [
		"fd4c",
		"chunk-e6cff0c8"
	],
	"./Index/homePage.vue": [
		"52a8",
		"chunk-2d2105cd",
		"chunk-e8860948",
		"chunk-7032a47d"
	],
	"./Index/homePage/AiModelSection.vue": [
		"cf9c",
		"chunk-37f98d37"
	],
	"./Index/homePage/CertificationSection.vue": [
		"778e",
		"chunk-578a30ee"
	],
	"./Index/homePage/CloudCard.vue": [
		"f314",
		"chunk-182a6260"
	],
	"./Index/homePage/CloudSection.vue": [
		"903a",
		"chunk-40c7a470"
	],
	"./Index/homePage/HeroSection.vue": [
		"65d63",
		"chunk-7ec65f4d"
	],
	"./Index/homePage/PlatformSection.vue": [
		"6c13",
		"chunk-e8860948"
	],
	"./Index/homePage/RobotSection.vue": [
		"e849",
		"chunk-520d87ad"
	],
	"./Index/index.vue": [
		"fbaf",
		"chunk-2d2105cd",
		"chunk-3b95d1a4"
	],
	"./about/index.vue": [
		"81b2",
		"chunk-443111da",
		"chunk-2d2105cd",
		"chunk-aaa35062",
		"chunk-4c9b49fd"
	],
	"./business/ai.vue": [
		"3dfa",
		"chunk-443111da",
		"chunk-2d2105cd",
		"chunk-aaa35062",
		"chunk-1ad55c15"
	],
	"./business/cloud.vue": [
		"e44f",
		"chunk-443111da",
		"chunk-2d2105cd",
		"chunk-aaa35062",
		"chunk-87372af2"
	],
	"./business/robot.vue": [
		"d9bd",
		"chunk-443111da",
		"chunk-2d2105cd",
		"chunk-aaa35062",
		"chunk-21d0bfaf"
	],
	"./coPlan/PartnerContent.vue": [
		"e4de",
		"chunk-e0bcd74e",
		"chunk-6c137696"
	],
	"./coPlan/coPlan.vue": [
		"e8aa",
		"chunk-443111da",
		"chunk-2d2105cd",
		"chunk-aaa35062",
		"chunk-e0bcd74e",
		"chunk-315325a0"
	],
	"./home/index.vue": [
		"f5b8",
		"chunk-443111da",
		"chunk-aaa35062",
		"chunk-7caa3462"
	],
	"./leapoAI/LeapoAiContent.vue": [
		"da35",
		"chunk-629a29d0",
		"chunk-6c137696"
	],
	"./leapoAI/leapoAI.vue": [
		"20b7",
		"chunk-443111da",
		"chunk-aaa35062",
		"chunk-629a29d0",
		"chunk-33e852a0"
	],
	"./market/AiMarketingContent.vue": [
		"4af6",
		"chunk-18e1b3d4",
		"chunk-6c137696"
	],
	"./market/market.vue": [
		"10e2",
		"chunk-443111da",
		"chunk-aaa35062",
		"chunk-18e1b3d4",
		"chunk-249fa772"
	],
	"./news/detail.vue": [
		"4afa",
		"chunk-443111da",
		"chunk-aaa35062",
		"chunk-61029a5b"
	],
	"./news/index.vue": [
		"9768",
		"chunk-443111da",
		"chunk-2d2105cd",
		"chunk-aaa35062",
		"chunk-789e545a"
	],
	"./nineToken/JiuciContent.vue": [
		"c780",
		"chunk-7d415c72"
	],
	"./nineToken/nineToken.vue": [
		"2802",
		"chunk-443111da",
		"chunk-aaa35062",
		"chunk-446a6ce0"
	],
	"./product/ai/ai-server.vue": [
		"0a5e",
		"chunk-443111da",
		"chunk-2d2105cd",
		"chunk-aaa35062",
		"chunk-473bf25e"
	],
	"./product/ai/analysis.vue": [
		"c26a",
		"chunk-443111da",
		"chunk-2d2105cd",
		"chunk-aaa35062",
		"chunk-53a423a9"
	],
	"./product/ai/call.vue": [
		"3d80",
		"chunk-443111da",
		"chunk-2d2105cd",
		"chunk-aaa35062",
		"chunk-d2d55e90"
	],
	"./product/ai/creation.vue": [
		"a33a",
		"chunk-443111da",
		"chunk-2d2105cd",
		"chunk-aaa35062",
		"chunk-04c17696"
	],
	"./product/ai/data-service.vue": [
		"d0b3",
		"chunk-443111da",
		"chunk-2d2105cd",
		"chunk-aaa35062",
		"chunk-60832111"
	],
	"./product/aiShopkeeper.vue": [
		"011e",
		"chunk-443111da",
		"chunk-2d2105cd",
		"chunk-aaa35062",
		"chunk-63e8cef8",
		"chunk-6f7095b9"
	],
	"./product/components/cardItem.vue": [
		"5587",
		"chunk-f862f1aa"
	],
	"./product/components/dsUpModule.vue": [
		"139d",
		"chunk-826a438e"
	],
	"./product/components/moduleBgBlue.vue": [
		"a8b8",
		"chunk-38d7e389"
	],
	"./product/components/moduleCenter.vue": [
		"c104",
		"chunk-720cb74d"
	],
	"./product/components/moduleTitle.vue": [
		"9582",
		"chunk-03f7703f"
	],
	"./product/components/topBanner.vue": [
		"d289",
		"chunk-433b92c9"
	],
	"./product/digitalSystem.vue": [
		"a3b7",
		"chunk-443111da",
		"chunk-aaa35062",
		"chunk-63e8cef8",
		"chunk-de280d90"
	],
	"./product/integration.vue": [
		"86a9",
		"chunk-443111da",
		"chunk-2d2105cd",
		"chunk-aaa35062",
		"chunk-63e8cef8",
		"chunk-1ee2f125"
	],
	"./product/intelligentService.vue": [
		"95f5",
		"chunk-443111da",
		"chunk-2d2105cd",
		"chunk-aaa35062",
		"chunk-63e8cef8",
		"chunk-3548804c"
	],
	"./product/onlineAndOfflineIntegration.vue": [
		"bc57",
		"chunk-443111da",
		"chunk-aaa35062",
		"chunk-63e8cef8",
		"chunk-052a8188"
	],
	"./product/onlineErp.vue": [
		"fd6e",
		"chunk-443111da",
		"chunk-aaa35062",
		"chunk-63e8cef8",
		"chunk-c45bdd92"
	],
	"./product/retailMall.vue": [
		"a9fc",
		"chunk-443111da",
		"chunk-aaa35062",
		"chunk-63e8cef8",
		"chunk-0dbdfd9a"
	],
	"./product/robot/lm200.vue": [
		"1e82",
		"chunk-443111da",
		"chunk-2d2105cd",
		"chunk-aaa35062",
		"chunk-214197a9"
	],
	"./product/robot/lm201.vue": [
		"db41",
		"chunk-443111da",
		"chunk-2d2105cd",
		"chunk-aaa35062",
		"chunk-48a12344"
	],
	"./product/robot/lm202.vue": [
		"593f",
		"chunk-443111da",
		"chunk-2d2105cd",
		"chunk-aaa35062",
		"chunk-97447116"
	],
	"./product/robot/lm203.vue": [
		"8099f",
		"chunk-443111da",
		"chunk-2d2105cd",
		"chunk-aaa35062",
		"chunk-22dd5887"
	],
	"./product/robot/lm211.vue": [
		"3c1b",
		"chunk-443111da",
		"chunk-2d2105cd",
		"chunk-aaa35062",
		"chunk-5d56f492"
	],
	"./product/scrmProduct.vue": [
		"0382",
		"chunk-443111da",
		"chunk-aaa35062",
		"chunk-30624a9f"
	],
	"./qcSuper/QianchengContent.vue": [
		"e922",
		"chunk-6379c26a",
		"chunk-6c137696"
	],
	"./qcSuper/qcSuper.vue": [
		"faf4",
		"chunk-443111da",
		"chunk-aaa35062",
		"chunk-6379c26a",
		"chunk-418cf6ac"
	],
	"./qccloud/b2bChannel.vue": [
		"e3ad",
		"chunk-443111da",
		"chunk-2d2105cd",
		"chunk-aaa35062",
		"chunk-135292a3",
		"chunk-4cdeafcd"
	],
	"./qccloud/digit.vue": [
		"e036",
		"chunk-443111da",
		"chunk-2d2105cd",
		"chunk-aaa35062",
		"chunk-135292a3",
		"chunk-366e3c82"
	],
	"./qccloud/digitalSystem.vue": [
		"e563",
		"chunk-443111da",
		"chunk-2d2105cd",
		"chunk-aaa35062",
		"chunk-135292a3",
		"chunk-c588c68a"
	],
	"./qccloud/live.vue": [
		"e6fe",
		"chunk-443111da",
		"chunk-2d2105cd",
		"chunk-aaa35062",
		"chunk-135292a3",
		"chunk-cfc84556"
	],
	"./qccloud/marketing.vue": [
		"0389",
		"chunk-443111da",
		"chunk-2d2105cd",
		"chunk-aaa35062",
		"chunk-135292a3",
		"chunk-2b81cb0b"
	],
	"./qccloud/onlineAndOfflineIntegration.vue": [
		"8c91",
		"chunk-443111da",
		"chunk-2d2105cd",
		"chunk-aaa35062",
		"chunk-135292a3",
		"chunk-1755e9f8"
	],
	"./qccloud/onlineErp.vue": [
		"d893",
		"chunk-443111da",
		"chunk-2d2105cd",
		"chunk-aaa35062",
		"chunk-135292a3",
		"chunk-7cf7ee74"
	],
	"./qccloud/retailMall.vue": [
		"5c71",
		"chunk-443111da",
		"chunk-2d2105cd",
		"chunk-aaa35062",
		"chunk-135292a3",
		"chunk-ab128a4e"
	],
	"./qccloud/s2b2c.vue": [
		"0b05",
		"chunk-443111da",
		"chunk-2d2105cd",
		"chunk-aaa35062",
		"chunk-135292a3",
		"chunk-7ced8e0a"
	],
	"./qccloud/scrmProduct.vue": [
		"1820",
		"chunk-443111da",
		"chunk-2d2105cd",
		"chunk-aaa35062",
		"chunk-135292a3",
		"chunk-ee53c8b8"
	],
	"./qccloud/shopkeeper.vue": [
		"a01a",
		"chunk-443111da",
		"chunk-2d2105cd",
		"chunk-aaa35062",
		"chunk-135292a3",
		"chunk-710f14e0"
	],
	"./qccloud/tool.vue": [
		"79e3",
		"chunk-443111da",
		"chunk-2d2105cd",
		"chunk-aaa35062",
		"chunk-135292a3",
		"chunk-14096dd0"
	],
	"./solution/QcDownload.vue": [
		"9d4c",
		"chunk-2d2105cd",
		"chunk-147dfafc"
	],
	"./solution/components/banner.vue": [
		"f53d",
		"chunk-443111da",
		"chunk-aaa35062",
		"chunk-2450dcd4"
	],
	"./solution/components/floor2.vue": [
		"0028",
		"chunk-1d8ecb8d"
	],
	"./solution/index.vue": [
		"60e0",
		"chunk-443111da",
		"chunk-aaa35062",
		"chunk-40162792",
		"chunk-12171154"
	],
	"./solution/live.vue": [
		"b92d",
		"chunk-443111da",
		"chunk-aaa35062",
		"chunk-40162792",
		"chunk-50f91793"
	],
	"./solution/retail.vue": [
		"6bef",
		"chunk-443111da",
		"chunk-aaa35062",
		"chunk-40162792",
		"chunk-aca1fab2"
	],
	"./solution/shopping.vue": [
		"83a8",
		"chunk-443111da",
		"chunk-aaa35062",
		"chunk-6bf0a376"
	],
	"./solution/store.vue": [
		"b8e9",
		"chunk-443111da",
		"chunk-aaa35062",
		"chunk-40162792",
		"chunk-e62af1ee"
	],
	"./solutions/robot/retail.vue": [
		"8498",
		"chunk-443111da",
		"chunk-aaa35062",
		"chunk-d1fa7828"
	],
	"./solutions/robot/security.vue": [
		"b7b8",
		"chunk-443111da",
		"chunk-aaa35062",
		"chunk-402ab9ea"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "a2f9";
module.exports = webpackAsyncContext;